export const USER_STATUS = {
  active: {
    id: 'active',
    label: {
      long: 'label.ACTIVE_USERS',
      short: 'label.ACTIVE'
    }
  },
  inactive: {
    id: 'inactive',
    label: {
      long: 'label.INACTIVE_USERS',
      short: 'label.INACTIVE'
    }
  }
};
